import { useEffect, useState } from "react";
import {useAppSelector} from "../store/hook";
import {UserInfoUtil} from "../utils/userInfoUtil";
import {SysBigDataService} from "../services/sys/sysBigDataService";
import {ResponseResultCode} from "../model/response-api";
import {AuthConstant} from "../constants/authConstant";
import {SysDataCollect} from "../model/common/sysModel";
import dayjs from "dayjs";
import ObjectUtil from "../utils/objectUtil";

type MgMdmsType = 'K' | 'M' | 'KM';

const useMgLatestTime = (viewType: MgMdmsType) => {
  const userInfo = useAppSelector(state => state.userInfo.userInfo);
  const [displayTime,setDisplayTime] = useState<dayjs.Dayjs>(dayjs());

  useEffect(() => {
    fetchLatestTimeByViewType(viewType);
  }, []);

  function fetchLatestTimeByViewType(mgMdmsType: MgMdmsType) {
    if (UserInfoUtil.isAdmin(userInfo)) {
      SysBigDataService.getInstance().getAdminLatestKPMGTime()
      .then(response => {
        if (response && ResponseResultCode.Y === response.resultCode) {
          setDisplayTimeByViewType(mgMdmsType, response.data);
        }
      });
    } else if (UserInfoUtil.hasRole(userInfo, AuthConstant.R001)) {
      SysBigDataService.getInstance().getLatestKPMGTime()
      .then(response => {
        if (response && ResponseResultCode.Y === response.resultCode) {
          setDisplayTimeByViewType(mgMdmsType, response.data);
        }
      });
    }
  }

  function setDisplayTimeByViewType(mgMdmsType: MgMdmsType, data: SysDataCollect) {
    const today = dayjs();
    const m = data.mgDataLatestDatetime;
    const k = data.mdmsDataLatestDatetime;

    if ('M' === mgMdmsType) {
      setDisplayTimeWithGivenValue(m, today);
    }
    else if ('K' === mgMdmsType) {
      setDisplayTimeWithGivenValue(k, today);
    }
    else if ('KM' === mgMdmsType) {
      if (!ObjectUtil.isEmpty(m) && !ObjectUtil.isEmpty(k)) {
        const mJs = dayjs(m);
        const kJs = dayjs(k);
        const diff = mJs.diff(kJs);
        if (diff > 0) {
          setDisplayTime(mJs.isValid() ? mJs : today);
        } else if (diff < 0) {
          setDisplayTime(kJs.isValid() ? kJs : today);
        } else {
          setDisplayTime(kJs.isValid() ? kJs : today);
        }
      } else if (!ObjectUtil.isEmpty(m)) {
        setDisplayTimeWithGivenValue(m, today);
      } else if (!ObjectUtil.isEmpty(k)) {
        setDisplayTimeWithGivenValue(k, today);
      } else {
        setDisplayTime(today);
      }
    }
  }

  function setDisplayTimeWithGivenValue(time: string | undefined, today: dayjs.Dayjs) {
    if (!ObjectUtil.isEmpty(time)) {
      const dayjsValue = dayjs(time);
      setDisplayTime(dayjsValue.isValid() ? dayjsValue : today);
    } else {
      setDisplayTime(today);
    }
  }

  return displayTime;
};

export default useMgLatestTime;